import api from '../api';
export interface PincodeRow {
  pincode: string; areas: string[]; cities: string[]; states: string[];
  posId: number | null; posName: string | null; isActive: boolean; isAssigned: boolean; modifiedDate: string | null;
}
export interface PincodeFilter { pincode: string; cityId: number | null; stateId: number | null; unassignedOnly: boolean; page: number; pageSize: number }
export interface PincodePage { totalCount: number; canEdit: boolean; items: PincodeRow[] }
export interface PincodeOption { id: number; name: string; stateId?: number }
export interface PincodeOptions { states: PincodeOption[]; cities: PincodeOption[]; outlets: PincodeOption[] }
export const MAPPING_CHANGED_KEY = 'pincodePosMappingsChanged';
export const emptyPincodeFilter: PincodeFilter = { pincode: '', cityId: null, stateId: null, unassignedOnly: false, page: 1, pageSize: 25 };
export async function getPincodeMappings(filter: PincodeFilter): Promise<PincodePage> {
  const { data } = await api.get<PincodePage>('/api/PincodePOS', { params: filter });
  if (!data || !Array.isArray(data.items) || typeof data.canEdit !== 'boolean' || !Number.isInteger(data.totalCount))
    throw new Error('Pincode mappings could not be loaded.');
  return data;
}
export async function getPincodeOptions(): Promise<PincodeOptions> {
  const { data } = await api.get<PincodeOptions>('/api/PincodePOS/options');
  if (!data || !Array.isArray(data.states) || !Array.isArray(data.cities) || !Array.isArray(data.outlets))
    throw new Error('Pincode filters could not be loaded.');
  return data;
}
export async function assignPincodes(rows: PincodeRow[], posId: number | null): Promise<number> {
  if (!rows.length || rows.length > 500 || new Set(rows.map(r => r.pincode)).size !== rows.length) throw new Error('Select up to 500 distinct pincodes.');
  const { data } = await api.post<{ changed: number }>('/api/PincodePOS/assign', { posId,
    pincodes: rows.map(r => ({ pincode: r.pincode, expectedPosId: r.posId, expectedIsActive: r.isActive, expectedModifiedDate: r.modifiedDate })) });
  if (!data || !Number.isInteger(data.changed) || data.changed < 0) throw new Error('The mapping update could not be confirmed. Refresh before trying again.');
  try { localStorage.setItem(MAPPING_CHANGED_KEY, Date.now().toString()); } catch { }
  window.dispatchEvent(new Event(MAPPING_CHANGED_KEY));
  return data.changed;
}
export function pincodeError(error: unknown): string {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  return typeof message === 'string' ? message : error instanceof Error && !('isAxiosError' in error) ? error.message : 'Could not save or load pincode mappings. Please retry.';
}
